export default "__VITE_ASSET__BiDn$AmG__"